<template>
  <div class="driverTaskDetail">
    <el-drawer
      size="890px"
      :title="title"
      :data="visible"
      :visible.sync="visible"
      :before-close="cancelModal"
    >
   <div class="tabs">
     <el-tabs v-model="active" >
    <el-tab-pane label="出场签单信息" name="1"></el-tab-pane>
    <el-tab-pane label="挖机签单信息" name="2"></el-tab-pane>
    <el-tab-pane label="审核流程" name="3"></el-tab-pane>
  </el-tabs>
   </div>
      <!-- <div class="tabs">
        <div
          :class="['tab', active == 1 ? 'active' : '']"
          @click="changeTab(1)"
        >
          出场签单信息
        </div>
        <div
          :class="['tab', active == 2 ? 'active' : '']"
          @click="changeTab(2)"
        > 
          挖机签单信息
        </div>
        <div
          :class="['tab', active == 3 ? 'active' : '']"
          @click="changeTab(3)"
        >
          审核流程
        </div>
      </div> -->
      <div v-if="active == 3">
        <div class="steps">
          <div class="step" v-for="(item, i) in flowList" :key="i">
            <div class="left">
              <div class="round"></div>
              <div class="line" v-if="i < flowList.length - 1"></div>
            </div>
            <div class="right">
              <div class="label">
                {{ item.approveUsername? item.approveUsername:(item.positionStaffName.replace(/\(待审批\)/g, ''))}}
                <div class="time">
                  {{ item.approveDatetime }}
                </div>
              </div>
              <div class="desc">
                {{ item.approveStatusText }}
              </div>
              <div class="textarea" v-if="item.approveRemark">
                {{ item.approveRemark }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <avue-form :value="row" :option="commonOption"> </avue-form>

        <div class="table-header">
          <div class="block">变更前</div>
          <div class="block">变更后</div>
        </div>
        <avue-form
          ref="editForm"
          v-model="editForm"
          :option="editOption1"
          v-if="active == 2"
          @submit="(form, done) => audit(2, done)"
        >
          <template slot="inPictureAf">
            <div>&nbsp;</div>
          </template>
          <template slot="inWeighInstrumentPictureAf">
            <div>&nbsp;</div>
          </template>
          <template slot-scope="{ disabled, size }" slot="statusList">
            <div>
              <el-tag
                v-if="statusForm.overtimeStatus"
                :type="statusForm.isOvertime == 1 ? 'danger' : ''"
                >{{ statusForm.overtimeStatus }}</el-tag
              >
              <el-tag
                v-if="statusForm.settleStatus"
                :type="statusForm.isSettle == 1 ? 'danger' : ''"
                style="margin-left: 10px"
                >{{ statusForm.settleStatus }}</el-tag
              >
              <el-tag
                v-if="statusForm.payStatus"
                :type="statusForm.isPay == 1 ? 'danger' : ''"
                style="margin-left: 10px"
                >{{ statusForm.payStatus }}</el-tag
              >
            </div>
          </template>
          <template slot-scope="{ disabled, size }" slot="flow">
            <div class="approvalInfo">
              <div
                class="info"
                style="width: 400px"
                v-if="flowList && flowList.length > 0"
              >
                <div class="approvalFlow">
                  <el-timeline>
                    <el-timeline-item
                      :timestamp="item.companyPositionName"
                      placement="top"
                      class="myActive"
                      color="#409eff"
                      v-for="(item, index) in flowList"
                      :key="index"
                    >
                      <i
                        :class="
                          item.isShow
                            ? 'el-icon-arrow-up'
                            : 'el-icon-arrow-down'
                        "
                        @click="showMore(item)"
                        v-if="item.approveStatus == 1"
                        style="
                          cursor: pointer;
                          position: absolute;
                          right: -20px;
                          top: 0px;
                          font-size: 18px;
                        "
                      ></i>
                      <div
                        style="
                          display: flex;
                          align-items: center;
                          justify-content: space-between;
                          margin-bottom: 10px;
                        "
                      >
                        <h4>{{ item.approveUsername }}</h4>
                        <span>{{ item.approveDatetime }}</span>
                      </div>
                      <el-input
                        type="textarea"
                        v-if="item.approveRemark"
                        v-model="item.approveRemark"
                        :autosize="{ minRows: 3, maxRows: 8 }"
                        disabled
                      ></el-input>
                      <div v-if="item.isShow">{{ item.positionStaffName }}</div>
                    </el-timeline-item>
                  </el-timeline>
                </div>
              </div>
              <el-empty v-else></el-empty>
            </div>
          </template>
          <template slot="menuForm">
            <el-button
              v-if="title == '审核'"
              icon="el-icon-close"
              @click="audit(3)"
              >驳回</el-button
            >
          </template>
        </avue-form>
        <avue-form
          ref="editForm"
          v-model="editForm"
          :option="editOption"
          v-if="active == 1"
          @submit="(form, done) => audit(2, done)"
        >
        <template slot="entranceTitleLabel">
          <div class="sub-title">
            入场签单信息
          </div>
        </template>
          <template slot="ticketImgAf">
            <div>&nbsp;</div>
          </template>
          <template slot="imgUrlAf">
            <div>&nbsp;</div>
          </template>

          <template slot-scope="{ disabled, size }" slot="statusList">
            <div>
              <el-tag
                v-if="statusForm.overtimeStatus"
                :type="statusForm.isOvertime == 1 ? 'danger' : ''"
                >{{ statusForm.overtimeStatus }}</el-tag
              >
              <el-tag
                v-if="statusForm.settleStatus"
                :type="statusForm.isSettle == 1 ? 'danger' : ''"
                style="margin-left: 10px"
                >{{ statusForm.settleStatus }}</el-tag
              >
              <el-tag
                v-if="statusForm.payStatus"
                :type="statusForm.isPay == 1 ? 'danger' : ''"
                style="margin-left: 10px"
                >{{ statusForm.payStatus }}</el-tag
              >
            </div>
          </template>
          <template slot-scope="{ disabled, size }" slot="flow">
            <div class="approvalInfo">
              <div
                class="info"
                style="width: 400px"
                v-if="flowList && flowList.length > 0"
              >
                <div class="approvalFlow">
                  <el-timeline>
                    <el-timeline-item
                      :timestamp="item.companyPositionName"
                      placement="top"
                      class="myActive"
                      color="#409eff"
                      v-for="(item, index) in flowList"
                      :key="index"
                    >
                      <i
                        :class="
                          item.isShow
                            ? 'el-icon-arrow-up'
                            : 'el-icon-arrow-down'
                        "
                        @click="showMore(item)"
                        v-if="item.approveStatus == 1"
                        style="
                          cursor: pointer;
                          position: absolute;
                          right: -20px;
                          top: 0px;
                          font-size: 18px;
                        "
                      ></i>
                      <div
                        style="
                          display: flex;
                          align-items: center;
                          justify-content: space-between;
                          margin-bottom: 10px;
                        "
                      >
                        <h4>{{ item.approveUsername }}</h4>
                        <span>{{ item.approveDatetime }}</span>
                      </div>
                      <el-input
                        type="textarea"
                        v-if="item.approveRemark"
                        v-model="item.approveRemark"
                        :autosize="{ minRows: 3, maxRows: 8 }"
                        disabled
                      ></el-input>
                      <div v-if="item.isShow">{{ item.positionStaffName }}</div>
                    </el-timeline-item>
                  </el-timeline>
                </div>
              </div>
              <el-empty v-else></el-empty>
            </div>
          </template>
          <template slot="menuForm">
            <el-button
              v-if="title == '审核'"
              icon="el-icon-close"
              @click="audit(3)"
              >驳回</el-button
            >
          </template>
        </avue-form>
        <avue-form
          v-if="title == '审核'"
          ref="remarkForm"
          v-model="remarkForm"
          :option="remarkOpt"
          @submit="(form, done) => audit(2, done)"
        >
          <template slot="reviewRemarkTitleLabel">
            <div class="check-title">审核备注</div>
          </template>
          <template slot="reviewRemarkTitle">
            <span></span>
            <!-- <div class="check-title">审核备注</div> -->
          </template>
          <template slot="reviewRemark">
            <div class="remark">
              <textarea
                type="textarea"
                v-model="remarkForm.reviewRemark"
                placeholder="请输入审核备注"
                maxlength="100"
              ></textarea>
            </div>
          </template>
          <template slot="menuForm">
            <!-- <el-button icon="el-icon-close" @click="audit(3)">驳回</el-button> -->
            <el-button @click="audit(3)">驳回</el-button>
            <el-button @click="audit(2)" type="primary">通过</el-button>
          </template>
        </avue-form>
      </div>
      <!-- <basic-container> -->

      <!-- </basic-container> -->
    </el-drawer>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {
  infoList,
  listByDriver,
  querySoilTypeByGarbage,
  auditUpdateHistory,
  listDriverCaptainTaskByProject,
  getProjectNewMatchOrderList,
} from "@/api/chain/companywaybill";
import {
  queryWaybillUpdateStatus,
  getFlowNode,
} from "@/api/chain/companywaybillupdatehistory";
export default {
  props: {
    //弹窗状态
    visible: {
      type: Boolean,
      default: false,
    },
    info: {},
    row: {},
    title: {
      type: String,
      default: "查看",
    },
  },
  data() {
    var validateRemark = (rule, value, callback) => {
      console.log(value);
      if (this.isRequired && (value === "" || !value)) {
        callback(new Error("请输入审批备注"));
      } else {
        callback();
      }
    };
    return {
      remarkForm: {},
      remarkOpt: {
        labelWidth: 150,
        submitText: "通过",
        submitIcon: " ",
        submitBtn: false,
        emptyBtn: false,
        menuPosition: "right",
        column: [
          {
            label: "审核备注",
            prop: "reviewRemarkTitle",
            span: 24,
          },
          {
            label: "",
            prop: "reviewRemark",
            display: this.title == "审核",
            // type: 'textarea',
            span: 24,
            maxlength: 100,
            rules: [
              {
                validator: validateRemark,
                trigger: "blur",
              },
            ],
          },
        ],
      },
      active: "1",
      editForm: {
        tpModeAf: 2,
      },
      isRequired: false,
      commonOption: {
        detail: true,
        labelPosition: "left",
        span: 8,
        column: [
          {
            label: "项目名称",
            prop: "projectInfoName",
          },
          {
            label: "运单号",
            prop: "companyWaybillNo",
          },
          {
            label: "运单状态",
            prop: "companyWaybillStatus",
          },
          {
            label: "申请人",
            prop: "createName",
          },
          {
            label: "申请时间",
            prop: "createDatetime",
          },
          {
            label: "审核状态",
            prop: "statusName",
          },
          {
            label: "变更原因",
            prop: "remark",

            span: 24,
          },
        ],
      },
      editOption: {
        labelSuffix: " ",
        detail: true,
        submitBtn: this.title == "审核",
        labelWidth: 150,
        submitText: "通过",
        position: "left",
        emptyBtn: false,
        cancelBtn: true,
        tabs: true,
        labelPosition: "left",
        group: [
          {
            label: "出场签单信息",
            arrow: false,
            prop: "group4",
            column: [
              {
                label: "司机手机号",
                prop: "mobile",
                disabled: true,
              },
              {
                label: "",
                prop: "mobileAf",
                className: "red",
                disabled: true,
                maxlength: 11,
              },
              {
                label: "司机车牌",
                prop: "truckCode",
                disabled: true,
              },
              {
                label: "",
                prop: "truckCodeAf",
                className: "red",
                disabled: true,
              },
              {
                label: "状态",
                prop: "status",
                disabled: true,
                type: "select", // 下拉选择
                dicData: [
                  {
                    label: "挖机签单已完成",
                    value: "1",
                  },
                  {
                    label: "出口签单已完成",
                    value: "2",
                  },
                  {
                    label: "司机签单已完成",
                    value: "3",
                  },
                  {
                    label: "司机卸土已完成",
                    value: "4",
                  },
                  {
                    label: "运单已取消",
                    value: "5",
                  },
                ],
              },
              {
                label: "",
                prop: "statusAf",
                className: "red",
                disabled: true,
                type: "select", // 下拉选择
                dicData: [
                  {
                    label: "挖机签单已完成",
                    value: "1",
                  },
                  {
                    label: "出口签单已完成",
                    value: "2",
                  },
                  {
                    label: "运单已取消",
                    value: "5",
                  },
                ],
              },
              {
                label: "车队长任务",
                prop: "driverCaptainTaskId",
                disabled: true,
                type: "select", // 下拉选择
                props: {
                  label: "name",
                  value: "task_id",
                },
              },
              {
                label: "",
                prop: "driverCaptainTaskIdAf",
                type: "select", // 下拉选择
                props: {
                  label: "name",
                  value: "task_id",
                },
                className: "red",
                disabled: true,
              },
              {
                label: "签单员工",
                prop: "goStaffId",
                disabled: true,
                type: "select",
                props: {
                  label: "name",
                  value: "id",
                },
                dicData: [],
              },
              {
                label: "",
                prop: "goStaffIdAf",
                className: "red",
                disabled: true,
                type: "select",
                props: {
                  label: "name",
                  value: "id",
                },
                dicData: [],
              },
              {
                label: "签单时间",
                prop: "goDatetime",
                disabled: true,
              },
              {
                label: "",
                prop: "goDatetimeAf",
                className: "red",
                disabled: true,
              },
              {
                label: "签单土质",
                prop: "goSoilType",
                disabled: true,
                type: "select",
                props: {
                  label: "name",
                  value: "name",
                },
                dicData: [],
              },
              {
                label: "",
                prop: "goSoilTypeAf",
                className: "red",
                disabled: true,
                type: "select",
                props: {
                  label: "name",
                  value: "name",
                },
                dicData: [],
              },
              {
                label: "出场班次日期",
                prop: "goShiftTime",
                disabled: true,
              },
              {
                label: "",
                prop: "goShiftTimeAf",
                className: "red",
                disabled: true,
              },
              {
                label: "签单班次",
                prop: "goShiftType",
                type: "select", // 下拉选择
                // dicUrl:"/chain/projectinfo/getShiftOfProject",
                // dicFormatter: (res) => {
                //   return res.data.map((item)=>{
                //     return {
                //       label:item,
                //       value:item,
                //     }
                //   })
                // },
                disabled: true,
              },
              {
                label: "",
                prop: "goShiftTypeAf",
                className: "red",
                disabled: true,
                type: "select",
                // dicUrl:"/chain/projectinfo/getShiftOfProject",
                // dicFormatter: (res) => {
                //   return res.data.map((item)=>{
                //     return {
                //       label:item,
                //       value:item,
                //     }
                //   })
                // },
              },
              {
                label: "运输类型",
                prop: "tpMode",
                type: "select",
                props: {
                  label: "itemName",
                  value: "itemValue",
                },
                dicUrl:
                  "/chain/systemdictionaryitem/listDictionaryItem?dictionary=tp_mode",
                disabled: true,
              },
              {
                label: "",
                prop: "tpModeAf",
                className: "red",
                disabled: true,
                type: "select",
                props: {
                  label: "itemName",
                  value: "itemValue",
                },
                dicUrl:
                  "/chain/systemdictionaryitem/listDictionaryItem?dictionary=tp_mode",
              },
              {
                label: "泥尾",
                prop: "garbageId",
                type: "select",
                typeformat(item, label, value) {
                  return item.isMatch == 1
                    ? `(撮合)${item[label]}`
                    : `${item[label]}`;
                },
                props: {
                  label: "name",
                  value: "id",
                },
                dicData: [],
                disabled: true,
              },
              {
                label: "",
                prop: "garbageIdAf",
                className: "red",
                disabled: true,
                type: "select",
                typeformat(item, label, value) {
                  return item.isMatch == 1
                    ? `(撮合)${item[label]}`
                    : `${item[label]}`;
                },
                props: {
                  label: "name",
                  value: "id",
                },
                dicData: [],
                filterable: true, //是否可以搜索
              },
              // {
              //   label: "撮合订单",
              //   prop: "matchOrderId",
              //   type: "select",
              //   props: {
              //     label: "orderNo",
              //     value: "id",
              //   },
              //   dicData: [],
              //   disabled: true,
              //   display:!!this.info.matchOrderIdAf||!!this.info.matchOrderId,
              // },
              // {
              //   label: "撮合订单变更后",
              //   prop: "matchOrderIdAf",
              //   type: "select",
              //   props: {
              //     label: "orderNo",
              //     value: "id",
              //   },
              //   className: "red",
              //   dicData: [],
              //   disabled: true,
              //   display:!!this.info.matchOrderIdAf||!!this.info.matchOrderId,
              // },
              {
                label: "泥尾票土质",
                prop: "goTicketSoilType",
                type: "select",
                dicData: [],
                disabled: true,
              },
              {
                label: "",
                prop: "goTicketSoilTypeAf",
                className: "red",
                disabled: true,
                type: "select",
                dicData: [],
              },
              {
                label: "票号",
                prop: "ticketNoText",
                disabled: true,
              },
              {
                label: "",
                prop: "ticketNoAf",
                className: "red",
                disabled: true,
              },
              {
                label: "泥尾票单价",
                prop: "ticketPrice",
                disabled: true,
              },
              {
                label: "",
                prop: "ticketPriceAf",
                className: "red",
                disabled: true,
              },
              {
                label: "资源类型",
                prop: "resourceType",
                type: "select",
                props: {
                  label: "itemName",
                  value: "itemValue",
                },
                dicUrl: `/chain/systemdictionaryitem/listDictionaryItem?dictionary=resource_type`,
                disabled: true,
              },
              {
                label: "",
                prop: "resourceTypeAf",
                className: "red",
                disabled: true,
                type: "select",
                props: {
                  label: "itemName",
                  value: "itemValue",
                },
                dicUrl: `/chain/systemdictionaryitem/listDictionaryItem?dictionary=resource_type`,
              },
              {
                label: "核销方式",
                prop: "checkMethod",
                type: "select",
                dicData: [
                  {
                    label: "收磅单",
                    value: "1",
                  },
                  {
                    label: "资源地",
                    value: "2",
                  },
                ],
                disabled: true,
              },
              {
                label: "",
                prop: "checkMethodAf",
                className: "red",
                disabled: true,
                type: "select",
                dicData: [
                  {
                    label: "收磅单",
                    value: "1",
                  },
                  {
                    label: "资源地",
                    value: "2",
                  },
                ],
              },
              {
                label: "资源地",
                prop: "resourceCustomerId",
                type: "select",
                props: {
                  label: "resourceType",
                  value: "id",
                },
                typeformat(item, label, value) {
                  return `${item["customerName"]}-${item["resourceType"]}`;
                },
                dicData: [],
                disabled: true,
              },
              {
                label: "",
                prop: "resourceCustomerIdAf",
                type: "select",
                props: {
                  label: "resourceType",
                  value: "id",
                },
                typeformat(item, label, value) {
                  return `${item["customerName"]}-${item["resourceType"]}`;
                },
                dicData: [],
                className: "red",
                disabled: true,
              },
              {
                label: "单位",
                prop: "weightUnit",
                type: "select",

                dicUrl: `/chain/systemdictionaryitem/listDictionaryItem?dictionary=weight_unit`,
                props: {
                  label: "itemName",
                  value: "itemValue",
                },
                disabled: true,
              },
              {
                label: "",
                prop: "weightUnitAf",
                disabled: true,
                type: "select",
                className: "red",
                dicUrl: `/chain/systemdictionaryitem/listDictionaryItem?dictionary=weight_unit`,
                props: {
                  label: "itemName",
                  value: "itemValue",
                },
                // change: (e) => {
                //   if (e.value == "车") {
                //     this.editForm.weightTonsAf = 1;
                //   }
                // },
                // control: (val) => {
                //   console.info(val)
                //   return {
                //     weightTonsAf: {
                //       disabled: val == "车",
                //     },
                //   };
                // },
              },
              {
                label: "数量",
                prop: "weightTons",
                controls: false,
                type: "number",
                precision: 2,
                minRows: 0,
                disabled: true,
              },
              {
                label: "",
                prop: "weightTonsAf",
                disabled: true,
                controls: false,
                precision: 2,
                minRows: 0,
                className: "red",
                change: (val) => {
                  // if (this.editForm.unitPriceAf && val.value) {
                  //   this.editForm.payeePriceAf = (
                  //     this.editForm.unitPriceAf * val.value
                  //   ).toFixed(2);
                  // }
                },
              },

              {
                label: "单价",
                prop: "unitPrice",
                disabled: true,
              },
              {
                label: "",
                prop: "unitPriceAf",
                disabled: true,
                className: "red",
                change: (val) => {
                  // if (this.editForm.weightTonsAf && val.value) {
                  //   this.editForm.payeePriceAf = (
                  //     this.editForm.weightTonsAf * val.value
                  //   ).toFixed(2);
                  // }
                },
              },
              {
                label: "价格",
                prop: "payeePrice",
                disabled: true,
                // display:this.info.isCubicPrice==1
              },
              {
                label: "",
                prop: "payeePriceAf",
                disabled: true,
                className: "red",
                // display:this.info.isCubicPrice==1
              },
              {
                label: "结算卡号",
                prop: "settleCardNo",
                disabled: true,
                display: this.info.settleType == 3 || this.info.settleType == 4,
              },
              {
                label: "",
                prop: "settleCardNoAf",
                display: this.info.settleType == 3 || this.info.settleType == 4,
                disabled: true,
                className: "red",
              },
              {
                label: "出口签单车型",
                prop: "goVehicleType",
                disabled: true,
                display: this.info.isGoVehicleType == 1,
              },
              {
                label: "",
                prop: "goVehicleTypeAf",
                display: this.info.isGoVehicleType == 1,
                disabled: true,
                className: "red",
              },
              {
                label: "地块",
                prop: "landParcel",
                disabled: true,
              },
              {
                label: "",
                prop: "landParcelAf",
                className: "red",
                disabled: true,
              },
              {
                label: "车队名称",
                prop: "captainFleetName",
                disabled: true,
              },
              {
                label: "",
                prop: "captainFleetNameAf",
                className: "red",
                disabled: true,
              },
              {
                label: "签单备注",
                prop: "goRemark",
                disabled: true,
              },
              {
                label: "",
                prop: "goRemarkAf",
                className: "red",
                disabled: true,
              },
              {
                label: "签单照片",
                prop: "goPicture",
                type: "upload",
                span: 12,
                listType: "picture-card",
                tip: "只能上传jpg/png文件",
                action: "/upms/file/upload?fileType=image&dir=",
                dataType: "string",
                propsHttp: {
                  url: "link",
                },
                disabled: true,
                readonly: true,
              },
              {
                label: "",
                prop: "goPictureAf",
                type: "upload",
                span: 12,
                listType: "picture-card",
                tip: "只能上传jpg/png文件",
                action: "/upms/file/upload?fileType=image&dir=",
                dataType: "string",
                propsHttp: {
                  url: "link",
                },
                disabled: true,
              },
              {
                label: "泥尾票照片",
                prop: "ticketImg",
                type: "upload",
                // span: 24,
                listType: "picture-card",
                tip: "只能上传jpg/png文件",
                action: "/upms/file/upload?fileType=image&dir=ticketImg/",
                propsHttp: {
                  url: "link",
                },
                disabled: true,
                readonly: true,
              },
              {
                label: "",
                prop: "ticketImgAf",
                type: "upload",
                // span: 24,
                listType: "picture-card",
                tip: "只能上传jpg/png文件",
                action: "/upms/file/upload?fileType=image&dir=ticketImg/",
                propsHttp: {
                  url: "link",
                },
                disabled: true,
              },
              {
                label: "拍照票据凭证",
                prop: "imgUrl",
                type: "upload",
                // span: 24,
                listType: "picture-card",
                tip: "只能上传jpg/png文件",
                action: "/upms/file/upload?fileType=image&dir=imgUrl/",
                propsHttp: {
                  url: "link",
                },
                disabled: true,
                readonly: true,
              },
              {
                label: "",
                prop: "imgUrlAf",
                type: "upload",
                // span: 24,
                listType: "picture-card",
                tip: "只能上传jpg/png文件",
                action: "/upms/file/upload?fileType=image&dir=imgUrl/",
                propsHttp: {
                  url: "link",
                },
                disabled: true,
              },
              // {
              //   label: "审核备注",
              //   prop: "auditRemark",
              //   disabled: this.title != "审核",
              //   display: this.title == "审核",
              //   // type: 'textarea',
              //   span: 24,
              //   maxlength: 100,
              //   rules: [
              //     {
              //       validator: validateRemark,
              //       trigger: "blur",
              //     },
              //   ],
              // },
              // {
              //   label: "运单状态",
              //   prop: "statusList",
              //   span: 24,
              // },
            ],
          },
        ],
      },
      editOption1: {
        detail: true,
        submitBtn: this.title == "审核",
        labelWidth: 150,
        submitText: "通过",
        position: "left",
        emptyBtn: false,
        cancelBtn: true,
        tabs: true,
        labelPosition: "left",
        group: [
          {
            label: "挖机签单信息",
            arrow: false,
            prop: "group3",
            column: [
              {
                label: "签单员工",
                prop: "inStaffId",
                cascader: ["machineId"],
                disabled: true,
                type: "select",
                props: {
                  label: "name",
                  value: "id",
                },
                dicData: [],
              },
              {
                label: "",
                prop: "inStaffIdAf",
                type: "select",
                cascader: ["machineIdAf"],
                className: "red",
                disabled: true,
                props: {
                  label: "name",
                  value: "id",
                },
                dicData: [],
              },
              {
                label: "签单机械型号",
                prop: "machineId",
                type: "select",
                props: {
                  label: "machineCode",
                  value: "id",
                },
                dicUrl:
                  "/chain/projectinfoext/getMachineListByPlatform?staffId={{key}}&projectInfoId=" +
                  this.info.projectInfoId,
                disabled: true,
              },
              {
                label: "",
                prop: "machineIdAf",
                type: "select",
                className: "red",
                disabled: true,
                props: {
                  label: "machineCode",
                  value: "id",
                },
                dicUrl:
                  "/chain/projectinfoext/getMachineListByPlatform?staffId={{key}}&projectInfoId=" +
                  this.info.projectInfoId,
              },
              {
                label: "签单时间",
                prop: "inDatetime",
                disabled: true,
              },
              {
                label: "",
                prop: "inDatetimeAf",
                className: "red",
                disabled: true,
              },
              {
                label: "签单土质",
                prop: "inSoilType",
                disabled: true,
              },
              {
                label: "",
                prop: "inSoilTypeAf",
                className: "red",
                disabled: true,
                type: "select",
                props: {
                  label: "name",
                  value: "name",
                },
                dicData: [],
              },
              {
                label: "挖机班次日期",
                prop: "inShiftTime",
                disabled: true,
              },
              {
                label: "",
                prop: "inShiftTimeAf",
                className: "red",
                disabled: true,
              },
              {
                label: "签单班次",
                prop: "inShiftType",
                type: "select", // 下拉选择
                // dicUrl:"/chain/projectinfo/getShiftOfProject",
                // dicFormatter: (res) => {
                //   return res.data.map((item)=>{
                //     return {
                //       label:item,
                //       value:item,
                //     }
                //   })
                // },
                disabled: true,
              },
              {
                label: "",
                prop: "inShiftTypeAf",
                className: "red",
                disabled: true,
                type: "select",
                // dicUrl:"/chain/projectinfo/getShiftOfProject",
                // dicFormatter: (res) => {
                //   return res.data.map((item)=>{
                //     return {
                //       label:item,
                //       value:item,
                //     }
                //   })
                // },
              },
              {
                label: "签单备注",
                prop: "inRemark",
                disabled: true,
              },
              {
                label: "",
                prop: "inRemarkAf",
                className: "red",
                disabled: true,
              },
              {
                label: "凭证类型",
                prop: "inWeightUnit",
                type: "radio",
                dicData: [
                  {
                    label: "车",
                    value: "车",
                  },
                  {
                    label: "吨",
                    value: "吨",
                  },
                ],
                disabled: true,
              },
              {
                label: "",
                prop: "inWeightUnitAf",
                type: "radio",
                className: "red",
                disabled: true,
                dicData: [
                  {
                    label: "车",
                    value: "车",
                  },
                  {
                    label: "吨",
                    value: "吨",
                  },
                ],
                control: (val) => {
                  console.log(val);
                  return {
                    inWeighInstrumentPicture: {
                      //泥尾票土质
                      display: val == "吨" || this.info.inWeightUnit == "吨",
                    },
                    inWeighInstrumentPictureAf: {
                      //泥尾票土质
                      display: val == "吨" || this.info.inWeightUnit == "吨",
                    },
                  };
                },
              },
              {
                label: "签单照片",
                prop: "inPicture",
                type: "upload",
                span: 12,
                listType: "picture-card",
                dataType: "string",
                propsHttp: {
                  url: "link",
                },
                tip: "只能上传jpg/png文件",
                action: "/upms/file/upload?fileType=image&dir=",
                disabled: true,
                readonly: true,
              },
              {
                label: "",
                prop: "inPictureAf",
                disabled: true,
                type: "upload",
                span: 12,
                listType: "picture-card",
                tip: "只能上传jpg/png文件",
                action: "/upms/file/upload?fileType=image&dir=",
                dataType: "string",
                propsHttp: {
                  url: "link",
                },
              },
              {
                label: "称重仪表照片",
                prop: "inWeighInstrumentPicture",
                type: "upload",
                span: 12,
                listType: "picture-card",
                tip: "只能上传jpg/png文件",
                action: "/upms/file/upload?fileType=image&dir=",
                propsHttp: {
                  url: "link",
                  name: "link",
                },
                dataType: "string",
                disabled: true,
                readonly: true,
              },
              {
                label: "",
                prop: "inWeighInstrumentPictureAf",
                type: "upload",
                span: 12,
                listType: "picture-card",
                tip: "只能上传jpg/png文件",
                action: "/upms/file/upload?fileType=image&dir=",
                propsHttp: {
                  url: "link",
                  name: "link",
                },
                dataType: "string",
                disabled: true,
                readonly: true,
              },
              {
                label: "审核备注",
                prop: "auditRemark",
                disabled: this.title != "审核",
                display: this.title == "审核",
                // type: 'textarea',
                span: 24,
                maxlength: 100,
                rules: [
                  {
                    validator: validateRemark,
                    trigger: "blur",
                  },
                ],
              },
              // {
              //   label: "运单状态",
              //   prop: "statusList",
              //   span: 24,
              // },
            ],
          },
        ],
      },
      entranceForm: [
        {
          label: "入场签单信息",
          prop:"entranceTitle",
          span: 24,
        },
        {
          label: "签单员工",
          prop: "entranceStaffId",
          disabled: true,
          type: "select",
          props: {
            label: "name",
            value: "id",
          },
        },
        {
          label: "",
          prop: "entranceStaffIdAf",
          className: "red",
          disabled: true,
          type: "select",
          props: {
            label: "name",
            value: "id",
          },
        },
        {
          label: "签单时间",
          prop: "entranceDatetime",
          disabled: true,
        },
        {
          label: "",
          prop: "entranceDatetimeAf",
          className: "red",
          disabled: true,
        },
        {
          label: "入场班次日期",
          prop: "entranceShiftTime",
          disabled: true,
        },
        {
          label: "",
          prop: "entranceShiftTimeAf",
          className: "red",
          disabled: true,
        },
        {
          label: "入场班次",
          prop: "entranceShiftType",
          disabled: true,
        },
        {
          label: "",
          prop: "",
          className: "red",
          disabled: true,
        },
        {
          label: "签单备注",
          prop: "entranceRemark",
          disabled: true,
        },
        {
          label: "",
          className: "red",
          disabled: true,
          prop: "entranceRemarkAf",
        },
        {
          label: "签单照片",
          prop: "entrancePicture",
          type: "upload",
          span: 12,
          listType: "picture-card",
          tip: "只能上传jpg/png文件",
          action: "/upms/file/upload?fileType=image&dir=",
          dataType: "string",
          propsHttp: {
            url: "link",
          },
          disabled: true,
          readonly: true,
        },
        {
          label: "",
          prop: "entrancePictureAf",
          type: "upload",
          span: 12,
          listType: "picture-card",
          tip: "只能上传jpg/png文件",
          action: "/upms/file/upload?fileType=image&dir=",
          dataType: "string",
          propsHttp: {
            url: "link",
          },
          disabled: true,
        },
        // {
        //   label: "审核备注",
        //   prop: "auditRemark",
        //   disabled: this.title != "审核",
        //   display: this.title == "审核",
        //   // type: 'textarea',
        //   span: 24,
        //   maxlength: 100,
        //   rules: [
        //     {
        //       validator: validateRemark,
        //       trigger: "blur",
        //     },
        //   ],
        // },
        // {
        //   label: "运单状态",
        //   prop: "statusList",
        //   span: 24,
        // },
      ],
      flowForm: {
        label: "审核流程",
        arrow: false,
        prop: "group6",
        column: [
          {
            label: "",
            prop: "flow",
            labelWidth: 0,
            span: 24,
          },
        ],
      },
      statusForm: {},
      flowList: [],
    };
  },
  created() {},
  mounted: function () {
    this.editForm = this.info;
    console.log(this.editForm);
    //配置了入场签单
    if (this.editForm.isEntranceWaybill == 1) {
      this.editOption.group[0].column=this.editOption.group[0].column.concat(this.entranceForm);
    }
    this.editForm.ticketNoText =
      this.editForm.ticketNo && this.editForm.manualSelectTicket == "0"
        ? `${this.editForm.ticketNo}(系统分配)`
        : this.editForm.ticketNo || "";
    //查看增加审核流程
    if (this.title != "审核") {
      this.editOption.group.push(this.flowForm);
    }
    infoList({
      projectInfoId: this.editForm.projectInfoId,
      selectType: 6,
      garbageDelStatus: 2, //有这个参数就包括查询无效泥尾
    }).then((res) => {
      this.$refs.editForm.updateDic("inStaffId", res.data.data.inList);
      this.$refs.editForm.updateDic("inStaffIdAf", res.data.data.inList);
      this.$refs.editForm.updateDic("goStaffId", res.data.data.goList);
      this.$refs.editForm.updateDic("goStaffIdAf", res.data.data.goList);
      this.$refs.editForm.updateDic("inSoilTypeAf", res.data.data.soilList);
      this.$refs.editForm.updateDic("goSoilTypeAf", res.data.data.soilList);
      this.$refs.editForm.updateDic("garbageId", res.data.data.garbageList);
      this.$refs.editForm.updateDic("garbageIdAf", res.data.data.garbageList);
      //配置了入场签单
      if (this.editForm.isEntranceWaybill == 1) {
        this.$refs.editForm.updateDic("entranceStaffId", res.data.data.goList);
        this.$refs.editForm.updateDic(
          "entranceStaffIdAf",
          res.data.data.goList
        );
      }
    });
    listByDriver({ companyAuthId: this.editForm.companyAuthId }).then((res) => {
      this.$refs.editForm.updateDic("resourceCustomerId", res.data.data);
      this.$refs.editForm.updateDic("resourceCustomerIdAf", res.data.data);
    });
    querySoilTypeByGarbage({
      garbageId: this.editForm.garbageId,
      companyAuthId: this.editForm.companyAuthId,
    }).then((res) => {
      this.$refs.editForm.updateDic("goTicketSoilType", res.data.data);
      // this.$refs.editForm.updateDic("goTicketSoilTypeAf",res.data.data)
    });
    //如果有撮合订单，需要先搜索一遍
    if (this.editForm.matchOrderId) {
      getProjectNewMatchOrderList({
        garbageId: this.editForm.garbageId,
        pId: this.editForm.projectInfoId,
      }).then((res) => {
        this.$refs.editForm.updateDic("matchOrderId", res.data.data);
      });
    }
    if (this.editForm.matchOrderIdAf) {
      getProjectNewMatchOrderList({
        garbageId: this.editForm.garbageIdAf,
        pId: this.editForm.projectInfoId,
      }).then((res) => {
        this.$refs.editForm.updateDic("matchOrderIdAf", res.data.data);
      });
    }
    queryWaybillUpdateStatus({
      companyWaybillId: this.info.companyWaybillId,
    }).then((res) => {
      this.statusForm = res.data.data;
    });
    listDriverCaptainTaskByProject({
      projectInfoId: this.info.projectInfoId,
    }).then((res) => {
      console.log(res);
      this.$refs.editForm.updateDic("driverCaptainTaskId", res.data.data);
      this.$refs.editForm.updateDic("driverCaptainTaskIdAf", res.data.data);
    });
    //获取审批流程信息
    getFlowNode(this.info.id).then((res) => {
      this.flowList = res.data.data;
    });
  },
  computed: {
    ...mapGetters(["permissions"]),
  },
  methods: {
    changeTab(val) {
      this.active = val;
    },
    cancelModal() {
      this.$emit("update:visible", false);
    },
    audit(type, done) {
      if (type == 3) {
        this.isRequired = true;
        console.log(this.$refs.editForm);
        this.$refs.remarkForm.validateField("reviewRemark");
        this.isRequired = false;
        if (!this.remarkForm.reviewRemark) {
          this.$message.error("请输入审核备注");
          done && done();
          return false;
        }
      }
      // type 2审核通过  3驳回
      this.$confirm(`确认${type == 2 ? "通过" : "驳回"}?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          const loading = this.$loading({
            lock: true,
            text: "Loading",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });
          auditUpdateHistory({
            id: this.editForm.id,
            status: type,
            auditRemark: this.remarkForm.reviewRemark,
          })
            .then((res) => {
              loading.close();
              this.$message({
                showClose: true,
                message: "操作成功",
                type: "success",
              });
              this.$emit("update:visible", false);
              this.$emit("searchData");
            })
            .catch(() => {
              loading.close();
            });
        })
        .catch(() => {});
      done && done();
    },
    showMore(item) {
      console.log(item);
      this.$set(item, "isShow", !item.isShow);
      // item.isShow = !item.isShow
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .el-dialog__body {
  padding-top: 0;
}

/deep/ .el-drawer__header {
  margin-bottom: 10px;
}

/deep/ .drawerHeader {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

/deep/ .red {
  .el-form-item__content input {
    color: #35b1ff !important;
  }

  .is-checked .el-radio__label {
    color: #35b1ff !important;
  }

  .is-checked .el-radio__inner {
    border-color: #35b1ff;

    &::after {
      background-color: #35b1ff;
    }
  }
}

.el-timeline-item__timestamp {
  color: #333;
}

.el-timeline-item__content {
  color: #909399;
}

.myActive .el-timeline-item__tail {
  border-left: 2px solid #409eff;
}
.tabs {
  cursor: pointer;
  display: flex;
  align-items: center;
  margin-left: 30px;
  margin-top: 20px;
  // margin-bottom: 24px;
  .tab {
    font-weight: 500;
    font-size: 14px;
    color: #313133;
    margin-right: 56px;

    &.active {
      color: #35b1ff;
    }
  }
}
/deep/.el-collapse-item__wrap .avue-form__group--flex {
  background: #fff !important;
  margin-top: -25px;
}
// /deep/.el-tabs__header {
//   display: none;
// }
.custom-label {
  background: #F5F7FA;
  width: 100%;
}
.custom-value {
  background: #F5F7FA;
}
/deep/.el-form-item__label {
  padding-right: 0;
  padding-left: 30px;
}
/deep/.avue-form__group .el-col {
  padding: 0 !important;
}
.table-header {
  display: flex;
  align-items: center;
  height: 40px;
  line-height: 40px;
  padding: 0 32px;
  .block {
    width: 50%;
    text-align: center;
    background: #ededf0;
    font-weight: 500;
    padding-right: 15px;
    font-size: 14px;
    color: #313133;
  }
}
/deep/.el-collapse-item__wrap {
  // display: none;
}
/deep/.avue-form__group .el-col-12 {
  border-bottom: 1px solid #ededf0;
}
/deep/.el-form-item {
  margin-top: 5px;
  margin-bottom: 5px !important;
}
/deep/.el-upload-list--picture-card .el-upload-list__item {
  width: 48px;
  height: 48px;
  margin: 0;
}
/deep/.avue-upload {
  margin-left: 8px;
}
.sub-title {
  margin-top: 26px;
  margin-bottom: 5px;
  font-weight: 500;
  font-size: 14px;
  color: #313133;
}
/deep/.avue-form__group .el-col-8 {
  .el-form-item__label {
    padding-left: 0;
    width: auto !important;
  }
  .el-form-item {
    display: flex;
    // align-items: center;
    margin-bottom: 0 !important;

    .el-form-item__label {
      // line-height: 20px;
      padding-right: 0;
      white-space: nowrap;
      width: auto !important;
    }
    .el-form-item__content {
      margin-left: 0 !important;
      padding-left: 0;
    }
  }
}
/deep/.el-drawer .avue-form {
  padding: 0 32px;
}
/deep/.avue-form__group .el-col-16 {
  .el-form-item__label {
    padding-left: 0;
    width: auto !important;
  }
}
/deep/.avue-form__group .el-col-24 {
  .el-form-item__label {
    padding-left: 0;
    width: auto !important;
  }
  .el-form-item {
    display: flex;
    // align-items: center;
    margin-bottom: 0 !important;

    .el-form-item__label {
      // line-height: 20px;
      padding-right: 0;
      white-space: nowrap;
      width: auto !important;
    }
    .el-form-item__content {
      margin-left: 0 !important;
      padding-left: 0;
      width: 100%;
    }
  }
}
.steps {
  padding: 0 48px;
  .step {
    // height: 100px;
    display: flex;
    padding-bottom: 24px;
    .left {
      .round {
        width: 4px;
        height: 4px;
        border: 2px solid #35b1ff;
        border-radius: 50%;
        margin: 8px 0;
      }
      .line {
        margin-left: 3px;
        width: 2px;
        height: 100%;
        background: #35b1ff;
      }
    }
    .right {
      width: 100%;
      margin-left: 20px;
      .label {
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-weight: 400;
        font-size: 16px;
        color: #313133;
        margin-bottom: 4px;
        .time {
          font-weight: 400;
          font-size: 14px;
          color: #626266;
        }
      }
      .desc {
        font-weight: 400;
        font-size: 14px;
        color: #626266;
        margin-bottom: 8px;
      }
      .textarea {
        padding: 6px 10px;
        height: 88px;
        width: 100%;
        background: #F5F7FA;
        border-radius: 2px;
        border: 1px solid #ededf0;
        font-weight: 400;
        font-size: 14px;
        color: #939399;
      }
    }
  }
}
.check-title {
  font-weight: 500;
  font-size: 16px;
  color: #313133;
  margin-bottom: 15px;
}
.remark {
  width: 100%;

  textarea {
    border: 1px solid #ededf0;
    height: 88px;
    width: 100%;
    background: #ffffff;
    border-radius: 2px;
    box-sizing: border-box;
    padding: 6px 10px;
  }
}
/deep/.big-pic {
  .el-upload-list--picture-card .el-upload-list__item {
    width: 160px;
    height: 90px;
  }
  .avue-upload {
    margin-left: 0;
  }
}
/deep/.el-drawer__header {
  border-bottom: 1px solid #ededf0;
  padding: 11px 20px;
  margin-bottom: 0;
}
/deep/.avue--detail{
  .el-tabs__header {
  display: none;
}
}
</style>
